import Api from '@/api/Api'

export default {
  fetchAll () {
    return Api().get('AdminCountry/fetch_all')
  }
}



// WEBPACK FOOTER //
// ./src/api/AdminCountryAPI.js